import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import user from "./mcoupon/user";
import getListMenuUserSlice from "./menu/getMenuOfUser";

import Login from "./login/Login";
const persistConfig = {
  key: "data",
  storage,
  whitelist: ["user", "dashboard"],
};
export const rootReducers = combineReducers({
  Login,
  user,
  getListMenuUserSlice,
});
const persistedReducer = persistReducer(persistConfig, rootReducers);
export const store = configureStore({
  reducer: { persistedReducer }, // store nhận vào 1 reducer
  middleware: [thunk],
  devTools: process.env.NODE_ENV !== "production",
});
export const persistor = persistStore(store);
